// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import BaseViewModel from "./../factories/base-view-model";
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-pager";
import AppTabController from "../services/app-tab-controller";

function MyAccountViewModel(tabPage) {
    var self = this;
    BaseViewModel.call(this, tabPage);
    self.Bao = Bao;
    self.PageIndex = ko.observable(0);
    self.PageSize = ko.observable(10);
    self.TotalRows = ko.observable(0);
    self.Sorting = ko.observableArray();
    self.AssetCollection = ko.observableArray([]);
    self.SelectedAssetId = ko.observable();
    self.SelectedAsset = ko.observable();
    self.SelectedAssetRow = ko.observable({});
    self.PageIndex.subscribe(function () {
        self.PerformRefresh();
    });
    self.Sorting.subscribe(function () {
        self.PerformRefresh();
    });
    self.ShowAssetTab = function (item) {
        if (item != null) {
            var newTab = new TabPage();
            newTab.Url("ConfigurationItem");
            newTab.UrlData({
                id: item.ConfigurationItemId
            });
            newTab.ObjectId(item.ConfigurationItemId);
            AppTabController.AddTab(newTab);
        }
    };
    self.PerformRefresh = function () {
        var def = $.Deferred();
        self.RefreshGrid().then(function () {
            def.resolve();
        });
        return def.promise();
    };
    self.RefreshGrid = function () {
        tabPage.IsLoading(true);
        return Bao.post("MyAccount/GetUserAssetCollection", JSON.stringify({
            sessionTabId: tabPage.SessionTabId,
            pageIndex: self.PageIndex(),
            pageSize: self.PageSize(),
            sorting: self.Sorting()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedAssetRow(null);
            self.TotalRows(0);
            self.AssetCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.AssetCollection(searchResult.Models);
                self.TotalRows(searchResult.TotalRows);
            }
        });
    };
    self.Save = function () {
        return;
    };
    self.CompleteCheck = function () {
        return true;
    };
    self.init = function () {
        return self.PerformRefresh();
    };
    self.loaded = function () {
        return;
    };
}
Bao.inherit(MyAccountViewModel, BaseViewModel);
MyAccountViewModel.prototype.PermissionRefresh = "MyAccountRefresh";
export default MyAccountViewModel;